import { registerFilter } from './filter';
import compile from './compile';
import config from './config';

export default { config, compile, registerFilter };
